































































































import {Vue, Component, Prop, PropSync, Watch} from 'vue-property-decorator'
import { DatePickerWings, SelectWings } from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import { TemplateParamValue } from "@/store/settings/templates/types";

@Component({ components: { DatePickerWings, SelectWings } })
export default class AdditionalParamsCard extends Vue {
  @Prop({ required: true }) transport!: string;
  @Prop({ required: true }) partner_id!: number;
  @PropSync("params") template_params!: TemplateParamValue[];

  @Action("getTemplateParams") actionGetTemplateParams: any;
  @Getter("templateParams") templateParamsList: any;

  selected: any[] = [];

  loadTemplateParams() {
    this.actionGetTemplateParams({transport: this.transport.toLowerCase(), partner_id: this.partner_id});
  }

  addParam() {
    this.template_params.push({ template_params_list_id: null, value: '' });
  }

  removeSelected() {
    const selectedIds = this.selected.map(item => item.template_params_list_id);
    this.template_params = this.template_params.filter(param => !selectedIds.includes(param.template_params_list_id));
    this.selected = [];
  }

  selectedKey(index: number) {
    const item = this.template_params[index];
    const defaultVal = {
      id: null,
      type: 1,
      conditions: {
        string_min_length: 0,
        string_max_length: 255,
        number_min_value: 0,
        number_max_value: 10000,
        enum: []
      }
    };
    if (!item || item.template_params_list_id == null) return defaultVal;
    return this.templateParamsList.find((key: any) => key.id === item.template_params_list_id) || defaultVal;
  }

  filteredKeysList(currentIndex: number) {
    const selectedIds = this.template_params
        .filter((_, i) => i !== currentIndex)
        .map(p => p.template_params_list_id)
        .filter(id => id !== null);
    return this.templateParamsList.filter((key: any) => !selectedIds.includes(key.id));
  }

  onSelect(selectedItems: any[]) {
    this.selected = selectedItems;
  }

  onKeyChange(index: number) {
    const item = this.template_params[index];
    if (!item.template_params_list_id) item.value = '';
  }

  get validationRules() {
    return this.template_params.map((item, index) => {
      const key = this.selectedKey(index);
      if (!key || key.id == null) return 'required';

      if (key.type === 1) {
        const min = key.conditions?.string_min_length || 0;
        const max = key.conditions?.string_max_length || 255;
        return `required|min:${min}|max:${max}`;
      }

      if (key.type === 2) {
        const min = key.conditions?.number_min_value ?? 0;
        const max = key.conditions?.number_max_value ?? 1000000;
        return `required|numeric|min_value:${min}|max_value:${max}`;
      }

      return 'required';
    });
  }

  @Watch('partner_id')
  onPartnerIdChange(val: number) {
    if (val) {
        this.loadTemplateParams();
    }
  }
}
